export default function ({ app, store, redirect }) {
  const status = app.$cookiz.get(
    '__MOTIONROUTES_APPS_MANAGER_DOWNLOAD_SKIPPED'
  );
  if (status && status.isSkipped) {
    return redirect(`/apps-manager/product-ready`);
  }
  return true;
}
